<template>
  <v-layout row wrap justify-center mt-5>
    <v-flex xs12 sm10>
      <v-layout row wrap justify-center>
        <v-flex xs6 sm4 md4 class="fin-prueba-bor aligner">
          <image-app class="animated bounceIn" :imaSize="200" :imaSrc="'logos-icons/bullet-ok-roja'" imaAlt=""></image-app>
        </v-flex>
        <v-flex xs12 sm8 md8 class="aligner animated fadeInRight" pa-5>
          <ui-title-one :titleAccess="titleAccess" titleLevel="h2">
            <template slot="partOne">
              <slot name="partOne"></slot>
            </template>
            <template slot="partTwo">
              <slot name="partTwo"></slot>
            </template>
            <template slot="partThree">
              <slot name="partThree"></slot>
            </template>
          </ui-title-one>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    titleAccess: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/mixins";

@media (min-width: 600px) {
  .fin-prueba-bor {
    border-right: solid 3px #bbb;
  }
}
</style>




// WEBPACK FOOTER //
// act-pantallafinal.vue?fd3dd800